import styled from 'styled-components';

import { SYS_PAGE_MARGIN } from '@oneaudi/unified-web-alpha-common';

export const MainStyle = styled.main`
	background: ${(props) => props.theme.sys.color.canvas['200']};
	padding: 0 ${SYS_PAGE_MARGIN} 0 ${SYS_PAGE_MARGIN};
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	width: 100%;
	flex: 1;

	.gallery-wrapper {
		display: flex;
		flex-direction: column;
		min-width: 0;
		width: 100%;
		max-width: 1248px;
		height: max-content;
		align-self: center;
		padding: 0;
	}
`;

export const PaddingContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
